import React from 'react';
import styled from 'styled-components';

const StyledVerticalVideos = styled.div`
  display: flex;
  justify-content: center;
  position: relative;
  padding: 5rem 0;
  gap: 0.5rem;

  iframe {
    width: 100%;
    height: 710px;
  }

  @media only screen and (max-width: 930px) {
    flex-direction: column;
    align-items: center;

    iframe {
      width: fit-content;
    }
  }
`;

const VerticalVideos = ({ videoList }) => {
  return (
    <StyledVerticalVideos>
      {videoList.map((video, idx) => {
        return (
          <iframe
            key={idx}
            src={video.video.url}
            title={'name of video'}
            style={{ border: 'none' }}
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture; fullscreen"
            allowtransparency="true"
            scrolling="no"
            webkitallowfullscreen="true"
            mozallowfullscreen="true"
            allowFullScreen
          />
        );
      })}
    </StyledVerticalVideos>
  );
};
export default VerticalVideos;
